module.exports = function() {
  return new Worker(__webpack_public_path__ + "fcb3f95674f1ae7ad1dd.worker.js");
};